import React from 'react';
import { generateProgressiveMasks } from './generateMasks';
import { Box, BoxProps } from '@withjoy/joykit';

type ProgressiveBlurProps = {
  steps?: number;
  minStrength?: number;
  maxStrength?: number;
  containerProps?: BoxProps;
};

export const ProgressiveBlur = (props: ProgressiveBlurProps) => {
  const { steps = 7, minStrength = 1, maxStrength = 64, containerProps } = props;

  // Exponential scaling from minStrength to maxStrength
  const blurSteps = Array.from({ length: steps }, (_, i) => {
    const ratio = i / (steps - 1);
    return minStrength * (maxStrength / minStrength) ** ratio;
  });

  const masks = generateProgressiveMasks(steps);

  return (
    <Box
      position="absolute"
      width="100%"
      height="100%"
      overflow="visible"
      zIndex={1}
      {...containerProps}
    >
      {blurSteps.map((blur, idx) => (
        <Box
          key={idx}
          position="absolute"
          inset={0}
          pointerEvents="none"
          zIndex={idx}
          backdropFilter={`blur(${blur}px)`}
          style={{
            mask: masks[idx],
          }}
        />
      ))}
      <Box
        position="absolute"
        inset={0}
        pointerEvents="none"
        zIndex={steps}
        background={`linear-gradient(transparent 0%, #ffffff 80%)`}
      />
    </Box>
  );
};
